const _excluded = ["customGroups"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Bucket } from 'common/widgets/bucket-pane/types';
import { ButtonReact } from 'common/components/button';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonTheme } from 'common/components/button/constants';
import { ENTER_KEY_CODE } from 'common/util/dom';
import { withStyles } from 'common/util/react';
import { Segmentation } from 'common/types/reports/query';
import { PropertyType } from 'common/report/constants';
import { TimeUnit } from 'common/widgets/date-range-picker/models/types';
import { useStagedState } from 'common/hooks/useStagedState';

// eslint-disable-next-line import/no-cycle
import { StringBucketPaneReact } from '../string-bucket-pane';
import { NumericBucketPaneReact } from '../numeric-bucket-pane';
import { DateBucketPaneReact, DateBucketPaneTimeGroup } from '../date-bucket-pane';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
export type SegmentBucketPaneProps = {
  eventNames?: string[];
  header?: string;
  maxNumBuckets?: number;
  onClose?: () => void;
  onUpdateSegment: (segment: Segmentation | null) => void;
  rangeMin?: number;
  resetBucket?: boolean;
  segment: Segmentation;
  selectedBucket?: Bucket;
  selectedUnit?: string;
  units?: string[] | Array<{
    value: string;
    label: string;
  }>;
  unitsAsProperty?: boolean;
};
export const SegmentBucketPane = withStyles((props: SegmentBucketPaneProps) => {
  var _segment$listItemGrou;
  const [editedBucket, setEditedBucket] = React.useState<Bucket | null>(null);
  const [segment, setSegment] = useStagedState<Segmentation | null>(props.segment, updatedSegment => {
    props.onUpdateSegment(updatedSegment);
  });
  const [validBucket, setValidBucket] = React.useState(true);
  const submitButton = React.useRef<any>(null);
  const {
    t
  } = useTranslation();
  const submitDisabled = !validBucket;
  const propertyType = (segment === null || segment === void 0 || (_segment$listItemGrou = segment.listItemGroup) === null || _segment$listItemGrou === void 0 ? void 0 : _segment$listItemGrou.propertyType) || (segment === null || segment === void 0 ? void 0 : segment.propertyType);
  const applyBucketSelections = () => {
    var _segment$listItemGrou2;
    const customBucket = !segment || segment.propertyType === PropertyType.Number || ((_segment$listItemGrou2 = segment.listItemGroup) === null || _segment$listItemGrou2 === void 0 ? void 0 : _segment$listItemGrou2.propertyType) === PropertyType.Number ? editedBucket !== null && editedBucket !== void 0 ? editedBucket : props.selectedBucket : undefined;

    // TODO: The `any` below here is because the way this component was set up
    // is a bit odd in that we're jamming stuff on the (nullable) segment within
    // the bucket component instead of just emitting what's updated (bucket and
    // unit) and then letting the parent control the updates. This should be
    // refactored.
    setSegment(_objectSpread(_objectSpread({}, segment), {}, {
      customBucket
    }) as any, true);
  };
  const handleKeyUp = (ev: TODO) => {
    if (ev.keyCode === ENTER_KEY_CODE && !submitDisabled) {
      applyBucketSelections();
    }
  };
  const handleSegmentUpdate = (_ref: {
    focusSubmit: boolean;
    isValid: boolean;
    updatedSegment: Segmentation;
  }) => {
    var _submitButton$current, _submitButton$current2;
    let {
      focusSubmit,
      isValid,
      updatedSegment
    }: {
      focusSubmit: boolean;
      isValid: boolean;
      updatedSegment: Segmentation;
    } = _ref;
    focusSubmit && ((_submitButton$current = submitButton.current) === null || _submitButton$current === void 0 || (_submitButton$current2 = _submitButton$current.focus) === null || _submitButton$current2 === void 0 ? void 0 : _submitButton$current2.call(_submitButton$current));
    if (segment !== null && segment !== void 0 && segment.listItemGroup) {
      // For list of objects, the segment passed to `StringBucketPaneEl` is segment.listItemGroup, so
      // we use the emitted segment to update segment.listItemGroup
      const {
          customGroups
        } = updatedSegment,
        listItemGroup = _objectWithoutProperties(updatedSegment, _excluded);
      updatedSegment = _objectSpread(_objectSpread({}, segment), {}, {
        listItemGroup,
        customGroups
      });
    }
    setSegment(updatedSegment);
    setValidBucket(isValid);
  };
  const resetInterval = () => {
    if (segment) {
      setSegment(_objectSpread(_objectSpread({}, segment), {}, {
        customBucket: undefined,
        customGroups: undefined
      }), true);
    } else {
      setSegment(null, true);
    }
  };
  const getPropertyUnit = () => {
    const unit = segment === null || segment === void 0 ? void 0 : segment.unit;
    if (unit === TimeUnit.Minute || unit === TimeUnit.Session) {
      throw new Error("".concat(unit, " time buckets are not allowed"));
    }
    return unit as DateBucketPaneTimeGroup;
  };
  const handleBucketUpdate = (_ref2: {
    bucket: Bucket;
    isValid: boolean;
  }) => {
    let {
      bucket,
      isValid
    }: {
      bucket: Bucket;
      isValid: boolean;
    } = _ref2;
    setEditedBucket(bucket);
    setValidBucket(isValid);
  };
  const handleUnitUpdate = (_ref3: {
    focusSubmit: boolean;
    isValid: boolean;
    unit: DateBucketPaneTimeGroup;
  }) => {
    var _submitButton$current3, _submitButton$current4;
    let {
      focusSubmit,
      isValid,
      unit
    }: {
      focusSubmit: boolean;
      isValid: boolean;
      unit: DateBucketPaneTimeGroup;
    } = _ref3;
    focusSubmit && ((_submitButton$current3 = submitButton.current) === null || _submitButton$current3 === void 0 || (_submitButton$current4 = _submitButton$current3.focus) === null || _submitButton$current4 === void 0 ? void 0 : _submitButton$current4.call(_submitButton$current3));
    if (segment) {
      setSegment(_objectSpread(_objectSpread({}, segment), {}, {
        unit: unit as Segmentation[`unit`]
      }));
    }
    setValidBucket(isValid);
  };
  const segmentParams = (() => {
    let params: {
      segment: Segmentation | null;
      listProperty?: Segmentation;
    } = {
      segment
    };
    if (segment !== null && segment !== void 0 && segment.listItemGroup) {
      // For list of objects, we pass segment.listItemGroup as the segment (and include the outer customGroups).
      // listProperty is also needed so the appropriate values query can be made using the listProperty
      params = {
        segment: _objectSpread(_objectSpread({}, segment.listItemGroup), segment.customGroups ? {
          customGroups: segment.customGroups
        } : {}),
        listProperty: segment
      };
    }
    return params;
  })();
  return <div className={styles.newStyle}>
      <div className={styles.mpBucketPane}>
        <div className={styles.inputSection} onKeyUp={handleKeyUp}>
          {propertyType === PropertyType.String || propertyType === PropertyType.List ? segmentParams.segment && <StringBucketPaneReact className={styles.inputPane} eventNames={props.eventNames || []} onUpdate={_ref4 => {
          let {
            focusSubmit,
            isValid,
            segment: updatedSegment
          } = _ref4;
          return handleSegmentUpdate({
            focusSubmit,
            isValid,
            updatedSegment
          });
        }} segment={segmentParams.segment} listProperty={segmentParams.listProperty} /> : propertyType === PropertyType.Number ? <NumericBucketPaneReact className={styles.inputPane} units={props.units} useNewDesign selectedBucket={editedBucket || props.selectedBucket} selectedUnit={props.selectedUnit} maxNumBuckets={props.maxNumBuckets} rangeMin={props.rangeMin} header={props.header} unitsAsProperty={props.unitsAsProperty} onUpdate={handleBucketUpdate} /> : propertyType === PropertyType.Datetime && <DateBucketPaneReact className={styles.inputPane} onUpdate={handleUnitUpdate} unit={getPropertyUnit()} />}
        </div>
        <div className={styles.footer}>
          {props.resetBucket && <ButtonReact className={styles.resetButton} elref='resetButton' theme={ButtonTheme.Tertiary} onClick={resetInterval}>
              {t("common.reset")}
            </ButtonReact>}
          <div className={styles.coreBtnGroup}>
            <ButtonReact theme={ButtonTheme.Tertiary} elref='cancelButton' onClick={() => {
            var _props$onClose;
            return (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
          }}>
              {t("common.cancel")}
            </ButtonReact>
            <ButtonReact className={styles.applyButton} disabled={submitDisabled} theme={ButtonTheme.Primary} elref='applyButton' onClick={applyBucketSelections} ref={submitButton}>
              {t("common.apply")}
            </ButtonReact>
          </div>
        </div>
      </div>
    </div>;
}, css);